var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-empty"},[_c('img',{staticClass:"home-empty__img",style:({ width: _vm.size + 'px' }),attrs:{"src":require("@/assets/dashboard/no-data-cloud.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.$t('there is no enough information for showing.')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }